import { MessageType } from "odyssey-shared";

/**
 * The server's `wallet` (P2.8-T38, ADR-124 decision 4.1, PROTOCOL.md 6) as the wallet store takes it. The text schema
 * has already checked every field when a message reaches here (each currency code once, of the code pattern, each
 * amount a whole number from 0 to `CURRENCY_MAX`, at most eight), so nothing is checked twice.
 */

/**
 * Each currency the character holds, by its code, in its smallest unit: Valish coin's `coin` in copper.
 */
export type WalletAmounts = Readonly<Record<string, number>>;

/**
 * A `wallet` as the wallet store takes it, or null for any other message.
 *
 * @param message A parsed server message.
 * @returns The amounts by currency code, or null.
 * @example
 * readWallet({ type: MessageType.Wallet, amounts: [["coin", 34512]] });
 * // { coin: 34512 }
 */
export function readWallet(message: Readonly<Record<string, unknown>> & { readonly type: number }): WalletAmounts | null {
  if (message.type !== MessageType.Wallet) {
    return null;
  }
  return Object.freeze(Object.fromEntries(message["amounts"] as readonly (readonly [string, number])[]));
}
